import { styled } from '@mui/material'

export const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  paddingBottom: theme.spacing(2.5),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(2.5),
}))

export const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row-reverse',
  gap: theme.spacing(1),
}))
